
let currentLang = 'zh_CN';
const localeMessages = {};
let i18nProps = null;

const getUrlParam = (name) => {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

const getEnvLanguage = () => {
  let state = null
  if (window.store && window.store.getState) {
    state = window.store.getState().toJS?.();
  }

  if (!state) {
    return null;
  }

  const { rootPageId, forms } = state;
  const form = forms[rootPageId];
  if (!form) {
    return null;
  }

  const lang = getNestedValue(form, 'config.language')
    || getNestedValue(form, 'config.langSetting.defaultLang');

  return lang;
};

const getBrowserLanguage = () => {
  if (typeof navigator !== 'undefined') {
    return navigator.language;
  }
  return null;
};

export const getLanguage = () => {
  const lang = getUrlParam('lang') || getUrlParam('language') || getEnvLanguage() || getBrowserLanguage();
  return lang || 'zh_CN';
};

let customBaseUrl = null;

export const setLanguage = async (lang) => {
  if (!lang) return;

  if (!localeMessages[lang]) {
    try {
      let url;
      if (customBaseUrl) {
        // 用户传入了自定义 url
        if (customBaseUrl.endsWith('.json')) {
          url = customBaseUrl;
        } else {
          url = `${customBaseUrl}lang/${lang}.json`;
        }
      } else if (i18nProps && i18nProps.isvId && i18nProps.moduleId && i18nProps.schemaId) {
        // 使用 props 拼接路径
        url = `${location.origin}${location.pathname}isv/${i18nProps.isvId}/${i18nProps.moduleId}/${i18nProps.schemaId}/lang/${lang}.json`;
      } else {
        // 默认路径
        url = `./lang/${lang}.json`;
      }
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        localeMessages[lang] = data;
      } else {
        console.warn(`[i18n] Failed to load language pack: ${url}`);
      }
    } catch (error) {
      console.error(`[i18n] Error loading language pack: ${error.message}`);
    }
  }

  currentLang = lang;
};

const getNestedValue = (obj, path) => {
  if (!obj) return undefined;
  return path.split('.').reduce((prev, curr) => {
    return prev && prev[curr];
  }, obj);
};

export const t = (key, values = {}) => {
  const messages = localeMessages[currentLang];

  let message = getNestedValue(messages, key);

  // 1. Handle missing
  if (message === undefined) {
    if (typeof values === 'object' && values.fallback !== undefined) {
        return values.fallback;
    }
    return key;
  }

  // If not string, return as is (e.g. object/array)
  if (typeof message !== 'string') {
      return message;
  }

  // 2. Handle Linked Messages (@:key)
  const linkRegex = /@:([\w\.]+)/g;
  if (linkRegex.test(message)) {
      message = message.replace(linkRegex, (match, linkedKey) => {
          return t(linkedKey, values);
      });
  }

  // 3. Handle Pluralization
  let count = null;
  let options = values;

  if (typeof values === 'number') {
      count = values;
      options = { count: values, n: values }; 
  } else if (typeof values === 'object') {
      if (values.count !== undefined) count = values.count;
      else if (values.n !== undefined) count = values.n;
  }

  if (count !== null && message.includes('|')) {
      const pipes = message.split('|').map(s => s.trim());
      if (pipes.length === 2) {
          // Format: singular | plural
          // Logic: 1 => singular, others => plural
          message = count === 1 ? pipes[0] : pipes[1];
      } else if (pipes.length >= 3) {
          // Format: zero | one | others
          // Logic: 0 => zero, 1 => one, others => others
          if (count === 0) message = pipes[0];
          else if (count === 1) message = pipes[1];
          else message = pipes[2];
      }
  }

  // 4. Interpolation
  // Support {{ key }}
  return message.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, param) => {
    return options[param] !== undefined ? options[param] : match;
  });
};

// Initialize language on load (optional, or user calls setLanguage)
// But requirements say "According to language load corresponding language pack"
// We can auto-initialize
export const init = async ({ props, url }) => {
    // 保存 props 供 setLanguage 使用
    if (props) {
        i18nProps = props;
    }
    // 保存自定义 url
    if (url) {
        customBaseUrl = url;
    }
    const lang = getLanguage();
    await setLanguage(lang);
    return lang;
};
